import React from "react";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import styles from "./Sidebar.module.css";
import { DashboardIcon } from "../../assets/icons/DashboardIcon";
import { NotesIcon } from "../../assets/icons/NotesIcon";
import { OrganizationIcon } from "../../assets/icons/OrganizationIcon";
import { ReportsIcon } from "../../assets/icons/ReportsIcon";
import { DealsIcon } from "../../assets/icons/DealsIcon";
import { SettingsIcon } from "../../assets/icons/SettingsIcon";
import { useAuth } from "../../context/AuthContext";

const ADMIN_LINKS = [
  { to: "/dashboard",    label: "Dashboard",    icon: DashboardIcon },
  { to: "/notes",        label: "Notes",        icon: NotesIcon },
  { to: "/deals",        label: "Deals",        icon: DealsIcon },
  { to: "/reports",      label: "Reports",      icon: ReportsIcon },
  { to: "/organization", label: "Organization", icon: OrganizationIcon },
  { to: "/settings",     label: "Settings",     icon: SettingsIcon },
];

// Non-admins: only Dashboard, Notes, Settings (as you specified).
const USER_LINKS = [
  { to: "/dashboard", label: "Dashboard", icon: DashboardIcon },
  { to: "/notes",     label: "Notes",     icon: NotesIcon },
  { to: "/settings",  label: "Settings",  icon: SettingsIcon },
];

function Sidebar() {
  const { role } = useAuth();
  const links = role === "admin" ? ADMIN_LINKS : USER_LINKS;

  return (
    <aside className={`${styles.sidebar} app-sidebar`}>
      <div className={styles.brand}>
        <span className={styles.brandMark}>CMBS</span>
        <span className={styles.brandMarkAccent}>DLT</span>
      </div>

      <ul className={styles.menu}>
        {links.map(({ to, label, icon: Icon }) => (
          <li className={styles.menuItem} key={to}>
            <NavLink
              to={to}
              className={({ isActive }) =>
                cn(styles.menuItemLink, { [styles.isActive]: isActive })
              }
            >
              <span className={styles.iconWrap}><Icon /></span>
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>

      <div className={styles.footer}>
        <span className={styles.roleChip} data-role={role || "user"}>{role || "user"}</span>
      </div>
    </aside>
  );
}

export default Sidebar;
